import React from 'react'
import Section from "../../../../Components/Section/Section";
import FormContainer from "../../../../Components/Form/FormContainer/FormContainer";
import Heading from "../../../../Components/Form/Heading/Heading";
import TextInput from "../../../../Components/Form/TextInput/TextInput";
import Button from "../../../../Components/Form/Button/Button";
import { formContent } from "./content"
import ImageUpload from "../../../../Components/Form/ImageUpload/ImageUpload";
import { useForm, FormProvider } from "react-hook-form";
// import { useHistory } from "react-router-dom";
import {getApiHost, getBusinessDetailsCookie, getResponseError, getUserDetailsCookie, setBusinessDetailsCookie} from "../../../../Api/Utils/apiUtils";
import ErrorAlert from "../../../../Components/Form/ErrorAlert/ErrorAlert";
import { useEffect, useState } from 'react';
import BusinessDetailsApi from '../../../../Api/BusinessDetailsApi';
import './../../../../Components/Accounts/businessprofile.css'

const BusinessProfileComponent = () => {
    const {
        heading,
        businessLogo,
        businessName,
        emailAddress,
        tradingName,
        businessAddress,
        ABN,
        firstName,
        lastName,
        mobileNumber,
        landlineNumber,
        faxNumber,
        webSiteUrl,
        facebookLink,
        InstagramLink,
        workingDay,
        opeingHours,
        closingHours,
        // GetBusinessInfoImage,
        updateButton
    } = formContent;

    const activedayStyle = {
        padding: '6px',
        backgroundColor: "#6930C1",
        border: "1px solid #cfcfcf",
        color:"#FFF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    }
    const nonactivedayStyle = {
        padding: '6px',
        backgroundColor: "#d1d1d1",
        border: "1px solid #cfcfcf",
        color:"#646464",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    }

    const [image, setImage] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [businessid, setbusinessid] = useState(null)
    const [selectedWorkingDay, setselectedWorkingDay] = useState([])
    const defaultworkingday = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"]

    useEffect(() => {
        const loadBusinessProfile = async () => {
            const user = getUserDetailsCookie()
            const businessDetailsResponse = await BusinessDetailsApi.getBusinessDetails(user.id)
            const businessApiError = getResponseError(businessDetailsResponse)
            if (businessApiError) {
                setErrorMessage(businessApiError)
            }else{
                const businessinformation = businessDetailsResponse.objectVal
                setBusinessDetailsCookie(businessinformation)
                setbusinessid(businessinformation.id)
                const setday = businessinformation.workingDay.split(",")
                setselectedWorkingDay(setday)

                businessinformation.businessLogo && setImage(businessinformation.businessLogo)
            }
        } 
        loadBusinessProfile()
    }, [])



    const bussiness = getBusinessDetailsCookie()
    if(bussiness.businessLogo && bussiness.businessLogo.imageUrl) {
        businessLogo.defaultImage = getApiHost() +'/'+ bussiness.businessLogo.imageUrl;
    }


    const formBinding = useForm({
        defaultValues: bussiness
    });


    const submitForm = async (data) => {
        let rearrangeworkday = ""
        for (let i = 0; i < selectedWorkingDay.length; i++) {
            if (selectedWorkingDay.length === i+1) {
                rearrangeworkday = rearrangeworkday+selectedWorkingDay[i]
            }else{
                rearrangeworkday = rearrangeworkday+selectedWorkingDay[i]+","
            }
        }
        data.workingDay = rearrangeworkday
        data.businessLogo = image
        data.busiId = businessid
        const response = await BusinessDetailsApi.updateBusinessDetails(data)
        const BusinessApiError = getResponseError(response)
        if (BusinessApiError) {
            setErrorMessage(BusinessApiError)
        }else{
            const updatedinformation = response.objectVal
            setBusinessDetailsCookie(updatedinformation)
            // window.location.reload()
        }
        rearrangeworkday = ""
    }

    const selectedWorkingDayHandle = (day) => {
        if (selectedWorkingDay.find(x => day === x)) {
            let fday = selectedWorkingDay.filter(y => y !== day)
            setselectedWorkingDay(fday)
            fday = []
        }else{
            setselectedWorkingDay([...selectedWorkingDay, day])
        }
    }

    const { watch, handleSubmit } = formBinding;
    watch(() => setErrorMessage(''));
    

    return (
        <Section>
            <FormContainer>
                <Heading>{heading}</Heading>
                <ErrorAlert>{errorMessage}</ErrorAlert>
                <FormProvider {...formBinding}>
                    <form id="profile-form" onSubmit={handleSubmit(submitForm)}>
                        <ImageUpload {...businessLogo} setImage={setImage} />
                        <TextInput {...businessName} />
                        <TextInput {...emailAddress} />
                        <TextInput {...tradingName} />
                        <TextInput {...businessAddress} />
                        <TextInput {...ABN} />
                        <TextInput {...firstName} />
                        <TextInput {...lastName} />
                        <TextInput {...mobileNumber} />
                        <TextInput {...landlineNumber} />
                        <TextInput {...faxNumber} />
                        <TextInput {...webSiteUrl} />
                        <TextInput {...facebookLink} />
                        <TextInput {...InstagramLink} />
                        <label style={{fontWeight:700, paddingLeft:"2px", color: "#666"}}>
                        {workingDay.label}</label>
                        <div className="working-day" style={{display: "grid", gridTemplateColumns: `repeat(7, 1fr)`, gap: "10px"}}>
                            {selectedWorkingDay.length > 0 && 
                                defaultworkingday.map((day, i) => {
                                    if (selectedWorkingDay.find(x => x === day)) {
                                        return(
                                            <div onClick={() => selectedWorkingDayHandle(day)} style={activedayStyle} key={`DAY${i}`} className="each-day">{day}</div>
                                        )
                                    }else{
                                        return(
                                            <div onClick={() => selectedWorkingDayHandle(day)} style={nonactivedayStyle} key={`DAY${i}`} className="each-day">{day}</div>
                                        )
                                    }
                                })
                            }
                        </div>
                        <TextInput {...opeingHours} />
                        <TextInput {...closingHours} />
                        <Button {...updateButton}/>
                    </form>
                </FormProvider>
            </FormContainer>
        </Section>
    )
}

export default BusinessProfileComponent
